import React from "react";
import { History } from "history";
import { Link, withRouter, RouteComponentProps } from "react-router-dom";

import { MeQuery } from "./graphql/user";
import { Menu, Dropdown } from "./semantic-ui";
import { loginUrl, userProfileUrl } from "./urls";
import { clearAuthResponse } from "./session";

type Props = RouteComponentProps<any> & {
  history: History;
  // Results of meQuery
  me: MeQuery["me"];
};

class AccountWidget extends React.Component<Props> {
  handleLogout = (e: React.MouseEvent) => {
    e.preventDefault();
    clearAuthResponse();
    this.props.history.push(loginUrl);
  };

  render() {
    const { me } = this.props;
    if (me) {
      return (
        <Dropdown item text={me.name}>
          <Dropdown.Menu>
            <Dropdown.Item as={Link} to={userProfileUrl(me.id)}>
              Your profile
            </Dropdown.Item>
            <Dropdown.Item onClick={this.handleLogout}>Log out</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      );
    } else {
      return (
        <Menu.Item as={Link} to={loginUrl} active color="teal">
          Log in
        </Menu.Item>
      );
    }
  }
}

export default withRouter(AccountWidget);
